/**
 * Created by johannes on 5/23/14.
 */

'use strict';
define('controller/trigger',[
    'jquery'
], function ($) {
    return {
        _mobileMenu: null,

        setMobileMenu: function (mobileMenuElement) {
            this._mobileMenu = mobileMenuElement;
        },

        getMobileMenu: function () {
            if (this._mobileMenu === null) {
                this._mobileMenu = $('.navigation.mobile');
            }
            return this._mobileMenu;
        },

        init: function (menuTrigger, mobileMenuElement) {
            var me = this;
            if (mobileMenuElement != null && typeof mobileMenuElement !== 'undefined') {
                this.setMobileMenu(mobileMenuElement);
            }

            menuTrigger.on('click', function () {
                me.showMobileMenu();
                me.appendClickBackground(menuTrigger);
            });
        },

        showMobileMenu: function () {
            this.validateElementsExists();
            this.getMobileMenu().toggleClass('open');
        },

        validateElementsExists: function () {
            if (this.getMobileMenu().length === 0) {
                console.error('No MobileMenuElement Found');
            }
        },

        appendClickBackground: function (menuTrigger) {
            var me = this;
            menuTrigger.parent().append('<div id="clickBlocker"></div>');

            $('#clickBlocker').on('click', function() {
                me.getMobileMenu().removeClass('open');
                $(this).remove();
            });
        }
    };
});
